const yinshimengMenuTitles: Record<string, string> = {
  首页: 'CRM管理',
  直播管理: '在线开发'
}

export function getMenuTitle(empNo: unknown, title: string) {
  return empNo === 'yinshimeng' ? yinshimengMenuTitles[title] ?? title : title
}
